/*
 * @Description: 
 * @Author: houcw
 * @Date: 2023-06-11 11:16:43
 * @LastEditTime: 2023-10-27 15:39:01
 * @LastEditors: houcw
 * @Reference: 
 */
import axios from 'axios'

//全局参数，自定义参数可在发送请求时设置
axios.defaults.timeout = 300000000 //超时时间ms
axios.defaults.withCredentials = true
// 请求时的拦截
//回调里面不能获取错误信息
axios.interceptors.request.use(
  (config) => {
    // if (config.method === "get") {
    //     config.paramsSerializer = function (params) {
    //         return qs.stringify(params, { arrayFormat: "repeat" });
    //     };
    // }
    // 是否需要设置 token
    config.headers !== undefined ? config.headers.Authorization = sessionStorage.getItem("adminToken") : "";
    return config;
  },
  function (error) {
    // 当请求异常时做一些处理
    console.log('请求异常：' + JSON.stringify(error));
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log('响应出错：' + error)
  return Promise.reject(error)
})


const base = {
  axios: axios,
  baseUrl: 'https://ai.vvmedic.com/api',
}

export default base
